import { PREFIX } from '../../constants';

const generateBgStyles = ({ controlName, attributes }) => {
    const {
        [`${PREFIX}${controlName}bgType`]: bgType = 'classic',
        [`${PREFIX}${controlName}bgColor`]: bgColor,
        [`${PREFIX}${controlName}bgGradient`]: bgGradient,
        [`${PREFIX}${controlName}bgImage`]: bgImage,
        [`${PREFIX}${controlName}bgImageSize`]: bgImageSize,
        [`${PREFIX}${controlName}bgImagePosition`]: bgImagePosition,
        [`${PREFIX}${controlName}bgImageAttachment`]: bgImageAttachment,
        [`${PREFIX}${controlName}bgImageRepeat`]: bgImageRepeat,
        [`${PREFIX}${controlName}bgImageOverlay`]: bgImageOverlay,
        [`${PREFIX}${controlName}bgImageOverlayColor`]: bgImageOverlayColor,
        [`${PREFIX}${controlName}bgImageOverlayOpacity`]: bgImageOverlayOpacity
    } = attributes;

    let bgStyle;
    if (bgType === 'classic') {
        bgStyle = bgColor ? `background-color: ${bgColor}; ` : '';
        if (bgImage && bgImage.url) {
            bgStyle += `background-image: url(${bgImage.url});
            background-size: ${bgImageSize};
            background-position: ${bgImagePosition};
            background-attachment: ${bgImageAttachment};
            background-repeat: ${bgImageRepeat};
            `;
        }

        if (bgImageOverlay) {
            bgStyle += `
                position: relative;
                z-index: 1;
                &:before {
                content: '';
                position: absolute;
                top: 0;
                z-index: -1;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: ${bgImageOverlayColor};
                opacity: ${bgImageOverlayOpacity};
            }
            `;
        }
    } else if (bgType === 'gradient' && bgGradient !== undefined && bgGradient !== '') {
        bgStyle = bgGradient
            ? `background-image: ${bgGradient};
        `
            : '';
    } else {
        bgStyle = '';
    }

    return {
        bgStyle
    };
};

export default generateBgStyles;
